export default __webpack_public_path__ + "static/media/cert2.be82a7ef.jpg";